import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import DialingInput from '../dialingInput';
import Keypad from '../keypad/keypad';
import Button from 's2s-button';
import Badge from '../badge';
import { track } from 's2s-app-service';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import useCallInfo from "../../hooks/callInfo";

const composedHoc = compose(injectIntl);
const ComposedButton = composedHoc(Button);
const ComposedKeypad = composedHoc(Keypad);
const ComposedDialingInput = composedHoc(DialingInput);

const UserActions = styled.div`
  width : 100%;
`;

const FooterControls = styled.div`
  align-items : center;
  background-color : ${colorGrid.gray0};
  border-top : 1px solid ${colorGrid.gray3};
  display : flex;
  height : 56px;
  justify-content : space-around;
`;

const VoiceMailButton = styled(ComposedButton)`
  background-color: ${colorGrid.gray0};
  border: none;
  cursor: pointer;
  display : flex;
  height : 40px;
  justify-content : center;
  padding: 0px; // Important not to squish SVG's
  width : 40px;

  &:hover {
    background: rgba(36, 57, 145, 0.04);
    border-radius: 4px;
  }
`;

const PhoneButton = styled(ComposedButton)`
  display : flex;
  justify-content : center;
  width : ${props => {
    return props.userControlStatus === "zero" ? "104px" : "calc(50% - 16px)";
  }};
  background-color: #099F24;
  
  &:hover {
    background-color: #066A18;
  }
`;

const CallHistoryButton = styled(VoiceMailButton)``;

const ZeroUserControls = (props) => {
  const [callInfo] = useCallInfo();
  const [phoneButtonDisabled, setPhoneButtonDisabled] = useState(false);

  // Setup voicemail button with badge of unread vm count
  let BadgedVoicemailButton = Badge(callInfo.voicemailCount, (e) => {
    props.cbUserAction('voicemail');
  })(VoiceMailButton);

  const handleMakeCallClick = () => {
    if (props.dialingInputValue.length > 0) {
      setPhoneButtonDisabled(true);
    }
    props.cbHandleCallClick();
  };


  return (
    <UserActions
      className="Zero UserActions"
      onKeyPress={props.cbHandleKeyPress}
    >
      <ComposedDialingInput
        cbBackspaceClick={props.cbHandleBackspaceClick}
        cbChange={props.cbHandleDialingInputChange}
        value={props.dialingInputValue}
      />
      <ComposedKeypad
        cbKeyPress={props.cbHandleKeypadClick}
        dtmfOutputDeviceId={props.dtmfOutputDeviceId}
        disableDTMFTone={props.disableDTMFTone}
      />
      <FooterControls className="FooterControls">
        <BadgedVoicemailButton
          className="VoiceMailButton"
          buttonSize="small"
          buttonType="secondary"
          svgType="MdVoicemail"
          svgFill="#4C5863"
          cbClick={(e) => {
            track("voicemail_button", "clicked");
            e.preventDefault();
            e.stopPropagation();
            props.cbUserAction('voicemail');
          }}
        />
        <PhoneButton
          className="PhoneButton"
          isDisabled={phoneButtonDisabled}
          buttonSize="medium"
          buttonType="primaryGreen"
          svgFill={colorGrid.gray0}
          svgType="MdPhone"
          cbClick={handleMakeCallClick}
          userControlStatus={props.userControlStatus}
        />
        <CallHistoryButton
          className="CallHistory"
          buttonSize="small"
          buttonType="secondary"
          svgType="MdHistory"
          svgFill="#4C5863"
          cbClick={props.cbCallHistoryClick}
        />
      </FooterControls>
    </UserActions>
  );
};


ZeroUserControls.propTypes = {
  cbCallHistoryClick: PropTypes.func,
  cbUserAction: PropTypes.func,
  intl: PropTypes.object,
  disableDTMFTone: PropTypes.bool,
  userControlStatus: PropTypes.string,
  cbHandleKeyPress: PropTypes.func,
  cbHandleBackspaceClick: PropTypes.func,
  cbHandleDialingInputChange: PropTypes.func,
  dialingInputValue: PropTypes.string,
  cbHandleKeypadClick: PropTypes.func,
  cbHandleCallClick: PropTypes.func,
  dtmfOutputDeviceId: PropTypes.string,
};

ZeroUserControls.defaultProps = {
  // cbCallHistoryClick: () => { },
  // cbUserAction: () => { },
  // cbHandleKeyPress: () => { },
  // cbHandleBackspaceClick: () => { },
  // cbHandleDialingInputChange: () => { },
  // cbHandleKeypadClick: () => { },
  // cbHandleCallClick: () => { },

};

export default injectIntl(ZeroUserControls);
